export default "__VITE_ASSET__de67b191__"